module.exports = __webpack_public_path__ + "static/imghover-d028c083a3a160974cb886682e5fa86f.png";